import React from 'react';
import { FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

import { Box, Typography } from '@mui/material';
import { concat, get } from 'lodash';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import Schema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { FormStrucItem } from 'src/lib/types/types';
import { mapindexbyPath } from 'src/utils/formStruc';
const MA_P = Schema.attributes;
const JA_AUSWAHLFELD = 'Ja44InDiesemVorhabenGibtEsWeitereMittelgeber';
export const FoerderungenAndererMittelgeberMAEpz = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title='Förderungen anderer Mittelgeber ' description={PLATZHALTER_TEXT} />
			<Typography>Bitte geben Sie hier an, ob es in Ihrem Vorhaben weitere Mittelgeber (öffentliche oder private Mittel) gibt.</Typography>
			<Box sx={{ mt: 2 }}>
				<CreateForm
					formValues={application}
					formStruc={formstrucWeitereMittelgeber()}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</Box>
			{get(application, MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Angabe_Weitere_Mittelgeber.path, '') === JA_AUSWAHLFELD && (
				<Box sx={{ mt: 2 }}>
					<Typography>
						Bitte laden Sie die Förderzusage(n) weiterer Mittelgeber für Ihr Vorhaben über das Upload-Feld hoch. Bei Bedarf können weitere
						Upload-Felder über das "+" hinzugefügt werden.
					</Typography>
					<CreateForm formValues={application} formStruc={formStrucUpload()} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
				</Box>
			)}
		</>
	);
};

const formstrucWeitereMittelgeber = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Angabe_Weitere_Mittelgeber,
					type: FORM_FIELDS_TYPES.radio,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucUpload = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Foerderzusagen,
					type: FORM_FIELDS_TYPES.editableTable,
					fieldProps: { Datei: { width: '20rem' } },
					preventLastElementDelete: true,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

const customFromStrucUpload = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Foerderzusagen.schema.attributes.Datei,
				// MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Foerderzusagen.schema.attributes.Bemerkungen_Zum_Dokument,
				MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Foerderzusagen.schema.attributes.Bezeichnung_Des_Dokuments,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	return struc;
};

export const getFormstrucFoerderungenAndererMittelgeberMAEpz = (application: any): FormStrucItem[] => {
	let result: FormStrucItem[] = [];

	result = concat(result, formstrucWeitereMittelgeber());
	if (get(application, MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Angabe_Weitere_Mittelgeber.path, '') === JA_AUSWAHLFELD) {
		const tableLength = get(application, MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Foerderzusagen.path, []).length;
		for (let i = 0; i < tableLength; i++) {
			const customFormStrucWithIndex = mapindexbyPath(customFromStrucUpload(), i, MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Foerderzusagen);
			result.push(...customFormStrucWithIndex);
		}
	}

	return result;
};
